module.exports = __webpack_public_path__ + "img/logo_fm_app.56af36cb.png";